import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import HostulLandingPage from './components/HostulLandingPage';
import PageSuporte from './components/suporte/PageSuporte';
import EngenhariaSitesPage from './components/EngenhariaSitesPage';
import WordpressLandingPage from './components/WordpressLandingPage';
import EmailProfissionalLandingPage from './components/EmailProfissionalLandingPage';
import CloudHostingLandingPage from './components/CloudHostingLandingPage';
import DomainRegisterLandingPage from './components/DomainRegisterLandingPage';
import LegalPage from './components/LegalPage';
import { useHashScroll } from './hooks/useHashScroll';

// Componente para tratar âncoras na URL globalmente
const HashHandler = () => {
  useHashScroll();
  return null;
};

function App() {
  // Remover o botão temporário de Engenharia de Sites
  return (
    <Router>
      <div>
        <HashHandler />
        <Routes>
          <Route path="/" element={<HostulLandingPage />} />
          <Route path="/suporte" element={<PageSuporte />} />
          <Route path="/engenharia" element={<EngenhariaSitesPage />} />
          <Route path="/wordpress" element={<WordpressLandingPage />} />
          <Route path="/email-profissional" element={<EmailProfissionalLandingPage />} />
          <Route path="/cloud" element={<CloudHostingLandingPage />} />
          <Route path="/dominios" element={<DomainRegisterLandingPage />} />
          <Route path="/legal" element={<LegalPage />} />
          <Route path="/legal/termosdeservico" element={<LegalPage />} />
          <Route path="/legal/contratodehospedagem" element={<LegalPage />} />
          <Route path="/legal/politicadeprivacidade" element={<LegalPage />} />
          <Route path="/legal/politicadereembolso" element={<LegalPage />} />
          <Route path="/legal/politicadeusoaceitavel" element={<LegalPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
